import React, {Component} from 'react'
import PropTypes from "prop-types"
import {reduxForm} from 'redux-form'
import {Form, Modal} from "react-bootstrap"
import {connect} from "react-redux";
import {showMessage} from '../../actions';
import {defaultState} from '../../reducers/entity';
import {BaseStatus, ExamType, ExamTypeLabel} from "../../utils/enums";
import {Date, resolveApiResult} from "../../utils";
import {showModal} from "../../actions/modal";
import {loadExam, saveExam} from "../../actions/exams";
import {loadFiles, saveFile} from "../../actions/files";
import {handleItemSave, ItemContext, onItemSaveSuccess, renderItemFormButtons, renderItemFormFiles} from "./helpers";
import ExamFields from "./ExamFields";

const validate = (values) => {
	const errors = {};
	if (!values.examType) {
		errors.examType = 'Zvolte prosím typ';
	}
	if (!values.examDate) {
		errors.examDate = 'Zadejte prosím datum';
	}
	if (!values.examBy) {
		errors.examBy = 'Vyberte prosím pracovníka';
	}
	if (values.examType === ExamType.VET && !values.examDoctor) {
		errors.examDoctor = 'Zadejte prosím lékaře';
	}
	if (!values.examResult) {
		errors.examResult = 'Uveďte prosím výsledek';
	}

	return errors
}

const textual = (item) => {
	return ExamTypeLabel[item.examType] + ' ' + Date.formatDate(item.examDate) + ' (ID ' + item.examId + ')';
}

export const createExamInitialValues = (examId, dogId, session) => {
	return examId
		? {dogId, examId}
		: {
			dogId,
			examDate: Date.format(Date.today(), Date.ISO_DATE),
			examBy: session.user.userId
		};
}

class ExamForm extends Component {

	ctx: ItemContext;

	constructor(props) {
		super(props);

		this.state = {
			currentFiles: []
		}

		this.handleSave = this.handleSave.bind(this);

		this.ctx = {
			itemTag: 'Prohlídka',
			itemKeyName: 'examId',
			saveItem: props.saveExam,
			saveFile: props.saveFile,
			showMessage: props.showMessage,
			textual,
			onSuccess: (item) => onItemSaveSuccess(item, props)
		}
	}

	componentWillMount() {
		const {exam} = this.props;
		if (exam.examId) {
			this.props.loadExam(exam.examId);
			this.props.loadFiles({examId: exam.examId, statuses: [BaseStatus.ACTIVE]}).then((json) => {
				if (resolveApiResult(json)) {
					this.setState({currentFiles: json.response.data});
				}
			});
		}
	}

	handleSave(values) {
		return handleItemSave(this.ctx, values);
	}

	render() {
		const {entity: {item, isFetchingItem}, modal} = this.props;

		return <Modal onHide={modal.onHide} show={true} backdrop={'static'} keyboard={false}>
			{(!item || isFetchingItem) ? null : this.renderForm()}
		</Modal>
	}

	renderForm() {
		const {entity: {item}, initialValues, handleSubmit, modal} = this.props;

		return <Modal onHide={modal.onHide} show={true} backdrop={'static'} keyboard={false}>
			<Modal.Header>
				<Modal.Title>{initialValues.examId ? 'Úprava prohlídky ID ' + initialValues.examId : 'Nová prohlídka'}</Modal.Title>
			</Modal.Header>

			<Form horizontal onSubmit={handleSubmit(this.handleSave)} className="detail">
				<Modal.Body>
					<ExamFields {...this.props} />
					{renderItemFormFiles(this.state.currentFiles)}
				</Modal.Body>

				<Modal.Footer>
					{renderItemFormButtons(this.ctx, item, this.props)}
				</Modal.Footer>
			</Form>
		</Modal>
	}
}

ExamForm = reduxForm({
	enableReinitialize: true,
	form: 'exam',
	validate
})(ExamForm);

const mapStateToProps = (state, ownProps) => {
	const {
		entities: {exams, dogs},
		enums,
		session
	} = state;

	const form = state.form['exam'];
	const {exam} = ownProps;

	const dog = ((dogs[exam.dogId] ? dogs[exam.dogId].item : exam.dog) || exam.dog) || {};

	const entity = exam.examId && exams[exam.examId]
		? exams[exam.examId]
		: {
			...defaultState,
			item: (form || {}).initial || (exam.examId ? null : {...exam})
		};

	return {
		entity,
		initialValues: entity.item,
		dog: dog,
		enums,
		session
	}
}

ExamForm.propTypes = {
	dog: PropTypes.object,
	exam: PropTypes.object.isRequired,
	loadExam: PropTypes.func.isRequired,
	loadFiles: PropTypes.func.isRequired,
	saveExam: PropTypes.func.isRequired,
	saveFile: PropTypes.func.isRequired,
	showModal: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	modal: PropTypes.object,
	enums: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
	loadExam,
	loadFiles,
	saveExam,
	saveFile,
	showMessage,
	showModal
})(ExamForm)



// WEBPACK FOOTER //
// ./src/components/dog/ExamForm.js